import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IGymListing } from "../../models/GymListing";
import { GymListingService } from "../../services/gym-listing.service";
import { IGymListingParams } from "../types";

export const useGetGymListingQuery = (data: IGymListingParams) => {
  return useQuery<{ data: IGymListing[]; totalCount: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_GYM_LISTING_WITH_PAGINATION, data],
    queryFn: () =>
      GymListingService.getGymListing(data.currentPage, data.pageSize, data.queryOptions).then(
        (res) => res.data
      ),
  });
};

export const useGetGymListingPreviewByIdQuery = (id: string | undefined) => {
  return useQuery<IGymListing, Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_LISTING_PREVIEW_BY_ID, id],
    queryFn: () => GymListingService.getGymListingPreviewById(id!).then((res) => res.data),
    enabled: !!id,
  });
};

export const useGetGymListingForAssignContractSelectQuery = () => {
  return useQuery<{ id: string; label: string }[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_LISTING_FOR_ASSIGN_CONTRACT_SELECT],
    queryFn: () => GymListingService.getGymListingForAssignContractSelect().then((res) => res.data),
  });
};
